<cs-content>
  <cs-card-list narrow>
    <cs-info-card type="translucent" [centered]="true" [dismissible]="false">
      <!-- Coach white-labeling (#3707): in the claim phase, swap the MH logo
           for the coach's logo when their branding is available. -->
      @if (claimBrandLogoUrl) {
        <img class="logo brand-logo" [src]="claimBrandLogoUrl" alt="" />
      } @else {
        <img class="logo" src="assets/imgs/logo.svg" />
      }
    </cs-info-card>
    <cs-card>
      @if (phase == LoginPhase.landing) {
      <div class="login-header">
        <div class="title">{{ LL.auth.welcomeToMhPhysique() }}</div>
      </div>
      <cs-item-list>
        <cs-item>
          <cs-button large item-right fit-width (click)="switchToPhase(LoginPhase.signIn)" type="button"
            [label]="LL.auth.signIn()">
          </cs-button>
        </cs-item>
      </cs-item-list>
      <div class="line-with-text">{{ LL.auth.dontHaveAccountYet() }}</div>
      <cs-item-list>
        <cs-item>
          <cs-button item-right class="login-option" fit-width secondary (click)="learnMore()" type="button"
            [label]="LL.auth.learnMore()">
          </cs-button>
        </cs-item>
      </cs-item-list>
      }
      @if (phase == LoginPhase.coachClaim) {
      @if (claimScreen == CoachClaimScreen.Checking) {
      <div class="claim-loading">
        <cs-spinner></cs-spinner>
      </div>
      } @else if (claimScreen == CoachClaimScreen.LinkRejected) {
      <div class="login-header">
        <div class="title">{{ LL.coach.claim.title() }}</div>
      </div>
      <cs-item-list>
        <div class="claim-description">{{ LL.coach.claim.invalidToken() }}</div>
      </cs-item-list>
      <cs-item-list>
        <cs-item>
          <cs-button large item-right secondary fit-width (click)="cancelClaim()" type="button"
            [label]="LL.common.buttons.cancel()">
          </cs-button>
        </cs-item>
      </cs-item-list>
      } @else if (claimScreen == CoachClaimScreen.CouldNotCheck) {
      <!-- the check never got an answer, so this must NOT say the link is bad. Try Again is the
           point of the screen: the token is unspent, so opening it again really does work. -->
      <div class="login-header">
        <div class="title">{{ LL.coach.claim.title() }}</div>
      </div>
      <cs-item-list>
        <div class="claim-description">{{ LL.coach.claim.couldNotCheckToken() }}</div>
      </cs-item-list>
      <cs-item-list>
        <cs-item>
          <cs-button large item-right fit-width (click)="retryClaimTokenCheck()" type="button"
            [label]="LL.common.buttons.tryAgain()">
          </cs-button>
        </cs-item>
      </cs-item-list>
      <cs-item-list>
        <cs-item>
          <cs-button large item-right secondary fit-width (click)="cancelClaim()" type="button"
            [label]="LL.common.buttons.cancel()">
          </cs-button>
        </cs-item>
      </cs-item-list>
      } @else {
      <div class="login-header">
        <div class="title">{{ LL.auth.welcomeToMhPhysique() }}</div>
        <div class="claim-description">{{ claimDescription() }}</div>
      </div>
      <div class="line-with-text">{{ LL.auth.claim.alreadyHaveAccount() }}</div>
      <cs-item-list>
        <cs-item>
          <cs-button large item-right fit-width (click)="claimLogin()" type="button" [label]="LL.auth.signIn()">
          </cs-button>
        </cs-item>
      </cs-item-list>
      <div class="line-with-text">{{ LL.auth.claim.newToMhPhysique() }}</div>
      <cs-item-list>
        <cs-item>
          <cs-button large item-right secondary fit-width (click)="claimRegister()" type="button"
            [label]="LL.auth.claim.createAccount()">
          </cs-button>
        </cs-item>
      </cs-item-list>
      }
      }
      @if (phase == LoginPhase.signIn || phase == LoginPhase.useEmailLink) {
      <div class="login-header">
        <div class="title">{{ LL.auth.loginToAccount() }}</div>
      </div>
      @if (phase == LoginPhase.signIn) {
      <cs-item-list>
        @if (allowLinkSignIn && (!this.email || !this.password)) {
        <cs-item>
          <cs-button item-right large type="button" fit-width (click)="switchToPhase(LoginPhase.useEmailLink)"
            [label]="LL.auth.signInByEmail()">
            <cs-icon name="link"></cs-icon>
          </cs-button>
        </cs-item>
        }
        @if (allowLinkSignIn && this.email && this.password) {
        <cs-item>
          <cs-button item-right large type="button" secondary fit-width (click)="switchToPhase(LoginPhase.useEmailLink)"
            [label]="LL.auth.signInByEmail()">
            <cs-icon name="link"></cs-icon>
          </cs-button>
        </cs-item>
        }
      </cs-item-list>
      <cs-item-list>
        @if (isIOSNative) {
        <cs-item>
          <cs-button item-right large class="login-option" id="login-apple" secondary fit-width
            (click)="loginWithApple()" type="button" [label]="LL.auth.signInWithApple()">
            <img src="assets/imgs/apple-logo.svg" alt="" />
          </cs-button>
        </cs-item>
        }
        <cs-item>
          <cs-button item-right large class="login-option" id="login-google" secondary fit-width
            (click)="loginWithGoogle()" type="button" [label]="LL.auth.signInWithGoogle()">
            <img src="assets/imgs/google-logo-color.svg" alt="" />
          </cs-button>
        </cs-item>
        @if (showAppleLoginOnWeb && isWeb) {
        <cs-item>
          <cs-button item-right large class="login-option" id="login-apple" secondary fit-width
            (click)="loginWithApple()" type="button" [label]="LL.auth.signInWithApple()">
            <img src="assets/imgs/apple-logo.svg" alt="" />
          </cs-button>
        </cs-item>
        }
      </cs-item-list>
      <div class="line-with-text">{{ LL.auth.or() }}</div>
      }
      <form class="login-form" (ngSubmit)="phase == LoginPhase.signIn ? handleLoginViaEmail() : handleLoginViaOTL()">
        <cs-form-field [label]="LL.auth.email()">
          <cs-input id="emailInput" type="email" [(value)]="email" name="email" autocomplete="username" iconName="mail"
            [placeholder]="LL.auth.enterYourEmail()">
          </cs-input>
        </cs-form-field>
        @if (phase == LoginPhase.signIn) {
        <cs-form-field [label]="LL.auth.password()">
          <cs-input id="passwordInput" type="password" [(value)]="password" name="password" autocomplete="password"
            iconName="lock-closed" [placeholder]="LL.auth.enterYourPassword()">
          </cs-input>
          @if (phase == LoginPhase.signIn) {
          <cs-button style="align-self: flex-end" tertiary [label]="LL.auth.forgotPassword()"
            (click)="handleForgotPassword()">
          </cs-button>
          }
        </cs-form-field>
        }
        @if (loginError) {
        <cs-text-alert type="error" [message]="loginError"></cs-text-alert>
        }
      </form>
      @if (phase == LoginPhase.signIn) {
      <cs-item-list>
        <cs-item>
          <cs-button large item-right id="submitButton" type="submit" fit-width
            [disabled]="!this.email || !this.password || waiting" (click)="handleLoginViaEmail()"
            [label]="waiting ? LL.auth.processing() : LL.auth.signIn()">
            @if (waiting) {
            <cs-spinner></cs-spinner>
            }
          </cs-button>
        </cs-item>
      </cs-item-list>
      }
      @if (phase == LoginPhase.useEmailLink) {
      <cs-item-list>
        <cs-item>
          <cs-button large item-right id="submitButton" type="submit" fit-width [disabled]="!this.email || waiting"
            (click)="handleLoginViaOTL()" [label]="waiting ? LL.auth.processing() : LL.auth.loginWithLink()">
            @if (!waiting) {
            <cs-icon name="link"></cs-icon>
            }
            @if (waiting) {
            <cs-spinner></cs-spinner>
            }
          </cs-button>
        </cs-item>
      </cs-item-list>
      }
      @if (phase == LoginPhase.useEmailLink && !isWebView) {
      <div class="line-with-text">{{ LL.auth.or() }}</div>
      <cs-item-list>
        <cs-item>
          <cs-button large item-right secondary fit-width (click)="switchToPhase(LoginPhase.signIn)" type="button"
            [label]="LL.auth.signInWithPassword()"></cs-button>
        </cs-item>
      </cs-item-list>
      }
      @if (isWebView && !isLoggedIn) {
      <cs-item-list>
        <cs-item>
          <cs-button item-right class="login-option" fit-width tertiary (click)="learnMore()" type="button"
            [label]="LL.auth.dontHaveAccountButton()"></cs-button>
        </cs-item>
      </cs-item-list>
      }
      @if (!isWebView) {
      <div class="sign-up-prompt">
        {{ LL.auth.dontHaveAccount() }} <span id="signUpHyperlink" class="clickable-link"
          (click)="switchToPhase(LoginPhase.newRegistration)">{{ LL.auth.signup() }}</span>
      </div>
      }
      }

      @if (phase == LoginPhase.newRegistration) {
      <div class="login-header">
        <div class="title">{{ LL.auth.createAccount() }}</div>
      </div>
      <form class="login-form" (ngSubmit)="handleSignUp()">
        <cs-form-field [label]="LL.auth.email()">
          <cs-input id="emailInput" type="email" [(value)]="email" name="email" autocomplete="username" iconName="mail"
            [placeholder]="LL.auth.enterYourEmail()">
          </cs-input>
        </cs-form-field>
        <cs-form-field [label]="LL.auth.firstLastName()">
          <cs-input id="realNameInput" type="text" [(value)]="realName" name="realName" autocomplete="name"
            iconName="person" [placeholder]="LL.auth.enterYourName()">
          </cs-input>
        </cs-form-field>
        <cs-form-field [label]="LL.auth.choosePassword()">
          <cs-input id="newPasswordInput" type="password" [(value)]="password" name="password"
            autocomplete="new-password" iconName="lock-closed" [placeholder]="LL.auth.chooseYourPassword()"></cs-input>
        </cs-form-field>
        @if (loginError) {
        <cs-text-alert type="error" [message]="loginError"></cs-text-alert>
        }
      </form>
      <cs-item-list>
        <cs-item>
          <cs-button large item-right id="signupButton" fit-width type="submit" (click)="handleSignUp()"
            [label]="waiting ? LL.auth.processing() : LL.auth.signUpWithEmail()"
            [disabled]="!this.email || !this.password || !this.realName || waiting">
            @if (!waiting) {
            <cs-icon name="mail"></cs-icon>
            }
            @if (waiting) {
            <cs-spinner></cs-spinner>
            }
          </cs-button>
        </cs-item>
      </cs-item-list>
      <div class="line-with-text">{{ LL.auth.orSignUpWith() }}</div>
      <cs-item-list>
        @if (isIOSNative) {
        <cs-item>
          <cs-button large item-right class="login-option" id="login-apple" secondary fit-width
            (click)="loginWithApple()" type="button" [label]="LL.auth.apple()">
            <img src="assets/imgs/apple-logo.svg" alt="" />
          </cs-button>
        </cs-item>
        }
        <cs-item>
          <cs-button large item-right class="login-option" id="login-google" secondary fit-width
            (click)="loginWithGoogle()" type="button" [label]="LL.auth.google()">
            <img src="assets/imgs/google-logo-color.svg" alt="" />
          </cs-button>
        </cs-item>
        @if (showAppleLoginOnWeb && isWeb) {
        <cs-item>
          <cs-button large item-right class="login-option" id="login-apple" secondary fit-width
            (click)="loginWithApple()" type="button" [label]="LL.auth.apple()">
            <img src="assets/imgs/apple-logo.svg" alt="" />
          </cs-button>
        </cs-item>
        }
      </cs-item-list>
      <div class="sign-up-prompt">
        {{ LL.auth.alreadyHaveAccount() }} <span id="signInHyperlink" class="clickable-link"
          (click)="switchToPhase(LoginPhase.signIn)">{{ LL.auth.login() }}</span>
      </div>
      }
      @if (phase == LoginPhase.subscriptionSuccess) {
      <div class="login-header">
        <div class="title">{{ LL.auth.subscriptionSuccess() }}</div>
        <cs-note light>{{ LL.auth.subscriptionSuccessCheckEmail() }}</cs-note>
        <cs-note light>{{ LL.auth.emailLinkContact() }} <a [href]="supportMailUrl">{{supportEmail}}</a>.</cs-note>
        <cs-store-badges [androidInstallUrl]="androidInstallUrl" [iosInstallUrl]="iosInstallUrl"></cs-store-badges>
      </div>
      }
      @if (phase == LoginPhase.emailLinkSent) {
      <div class="login-header">
        <div class="title">{{ LL.auth.emailLinkSent() }}</div>
        <cs-note light>{{ LL.auth.emailLinkSentMessage() }}</cs-note>
        <cs-note light>{{ LL.auth.emailLinkContact() }} <a [href]="supportMailUrl">{{supportEmail}}</a>.</cs-note>
      </div>
      }
    </cs-card>

    <cs-card-list-row class="login-legal-consent-row">
      <cs-note>
        <!-- legal-links row is intentionally one flat line: angular @if/@else
             blocks would otherwise pick up the newlines between tokens and
             render a stray space before commas / the terminal period
             ("Terms and Conditions , Privacy Policy , and EULA ."). do not
             re-format. -->
        {{ LL.auth.bySigningIn() }}<br><a [href]="tosUrl" target="_blank" rel="noopener" (click)="handleLegalLink($event, tosUrl)">{{ LL.auth.termsAndConditions() }}</a>@if (isIOSNative) {, <a [href]="privacyUrl" target="_blank" rel="noopener" (click)="handleLegalLink($event, privacyUrl)">{{ LL.auth.privacyPolicy() }}</a>, {{ LL.auth.and() }} <a [href]="eulaUrl" target="_blank" rel="noopener" (click)="handleLegalLink($event, eulaUrl)">{{ LL.auth.eula() }}</a>} @else { {{ LL.auth.and() }} <a [href]="privacyUrl" target="_blank" rel="noopener" (click)="handleLegalLink($event, privacyUrl)">{{ LL.auth.privacyPolicy() }}</a>}.
      </cs-note>
    </cs-card-list-row>

    <!-- Web-only Pricing + Refunds links. Together with the Terms and Privacy
         links in the "by signing in" note above, this gives a reviewer or
         crawler navigation access to all of Paddle's required pages (Pricing,
         Terms, Privacy, Refunds). Terms and Privacy are not repeated here to
         avoid duplicating the consent note. Hidden on native, where the app
         stores handle pricing/refunds. -->
    @if (isWeb) {
      <cs-card-list-row class="login-legal-footer-divider-row">
        <div class="login-footer-divider"></div>
      </cs-card-list-row>
      <cs-card-list-row class="login-legal-footer-row">
        <cs-note>
          <nav class="login-legal-footer">
            <a href="/subscribe">{{ LL.auth.pricing() }}</a>
            <a [href]="refundUrl" target="_blank" rel="noopener">{{ LL.auth.refunds() }}</a>
          </nav>
        </cs-note>
      </cs-card-list-row>
    }
  </cs-card-list>
  <!-- Spacer to prevent overlap with fixed version info -->
  <div class="version-spacer">
  </div>
</cs-content>
<cs-version-display></cs-version-display>